import axios from "axios";
import {
    UPDATE_WORK_PREFRENCE_REQUEST,
    UPDATE_WORK_PREFRENCE_SUCCESS,
    UPDATE_WORK_PREFRENCE_FAIL,
  } from "../constants/AuthConstant";
import { toast } from "react-toastify";


export const UpdateWorkPreferenceAction = (data) => {
    return function (dispatch) {
        dispatch({
            type: UPDATE_WORK_PREFRENCE_REQUEST,
            payload: true,
          });

          let OPTION = {
            url: `${process.env.REACT_APP_API_PATH}/ebench/work_preference/update_work_preference`,
            method: "PUT",
            data: data,
            headers: {
                "content-type": "application/json",
            },
          };

        axios(OPTION).then((res) => {
            dispatch(UpdateWorkPreference(res.data));
        })
        .catch((error) => {
            dispatch({
              type: UPDATE_WORK_PREFRENCE_FAIL,
              payload: false,
              error: error,
              uploadProImg: error.success,
              msg: "Failed to Upload",
            });
            toast.error(error.msg);
          });
    }
}


export const UpdateWorkPreference = (data) => {
    toast.success("Updated Successfully!");
    return {
      type: UPDATE_WORK_PREFRENCE_SUCCESS,
      result: data,
      payload: false,
      msg: data.status.message,
    };
  };